<script>
	export let title = "A solid arrow";
</script>

<!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52.45 52.45">
	<title>{title}</title>
	<path
	d="M.16,32.92H29.43l-7.72,7.72c-2.6,2.59-2.6,6.8,0,9.4,2.6,2.6,6.83,2.59,9.39,0l19.08-19.08c2.55-2.57,2.62-6.73,0-9.4L31.1,2.49C28.51-.11,24.3-.11,21.7,2.49c-2.6,2.6-2.6,6.8,0,9.4l7.72,7.72H.16" />
</svg> -->

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49.47 46.46" role="img">
	<title>{title}</title>
	<path
		d="M0,27.38H35.31l-11.99,11.99c-.79,.78-1.22,1.82-1.22,2.93,0,1.11,.43,2.15,1.22,2.94,.78,.78,1.83,1.22,2.94,1.22h.01c1.1,0,2.13-.43,2.9-1.21l19.09-19.09c1.62-1.63,1.61-4.22-.02-5.89L29.17,1.22c-.78-.79-1.82-1.22-2.93-1.22s-2.15,.43-2.93,1.22c-1.62,1.62-1.62,4.25,0,5.87l11.99,11.99H0" />
</svg>
